angular.module('aprima-core-ui')
    .directive('apPatientContextMenu', ['$rootScope', function ($rootScope) {
        'use strict';

        $rootScope.setOptsForPatientContextMenu = function setOptsForPatientContextMenu(opts) {
            $rootScope.$emit('select-patient', opts);
        };

        return {
            restrict: 'E',
            scope: {},
            templateUrl: '/core-ui/views/directives/apPatientContextMenu.html',
            controller: 'apPatientContextMenuCtrl'
        };
    }]);

angular.module('aprima-core-ui')
    .controller('apPatientContextMenuCtrl',
                ['$scope', '$rootScope', 'apConfirm', 'aprgettext', 'ChargeCaptureRepository','TransitionManager',
                    'toaster', 'ExternalPatientsRepository', 'LocalStorageRepository', 'SecurityRepository', 'Permissions', 'ClientInfoRepository',
        function ($scope, $rootScope, apConfirm, gettext, ChargeCaptureRepository, TransitionManager,
                    toaster, ExternalPatientsRepository, LocalStorageRepository, SecurityRepository, Permissions, ClientInfoRepository) {
            'use strict';

            function setup() {
                if(!$scope.patient) {
                    return;
                }

                $scope.isFndEnabled = ClientInfoRepository.isFndEnabled();

                SecurityRepository.getPermissions(Permissions.Schedule)
                    .then(function(permission) {
                        $scope.schedulePermissionAllowed = permission && permission.IsAllowed;
                    })
                    .catch(function() {
                        $scope.schedulePermissionAllowed = false;
                    });

                $scope.defaultServiceSiteId = LocalStorageRepository.getDefaultServiceSiteId();

                $scope.erxEnabled = LocalStorageRepository.getIsERxEnabled();

                var settings = LocalStorageRepository.getDashboardTileSettings();

                $scope.tiles = settings && settings.Tiles ? settings.Tiles : [];

                $scope.chargeCaptureOptions = {
                    patientId: $scope.patientId || ($scope.patient && $scope.patient.Id)
                };

                if ($scope.serviceSiteId) {
                    $scope.chargeCaptureOptions.serviceSiteId = $scope.serviceSiteId;
                }

                if ($scope.chargeCaptureId) {
                    $scope.chargeCaptureOptions.chargeCaptureId = $scope.chargeCaptureId;
                }
            }

            var deregister = $rootScope.$on('select-patient', function(evt, obj) {
                $scope.patient = obj && obj.patient;
                $scope.patientDashboardConfigurations = obj && obj.patientDashboardConfigurations;
                $scope.serviceSiteId = obj && obj.serviceSiteId;
                $scope.chargeCaptureId = obj && obj.chargeCaptureId;
                $scope.hospitalRoundId = obj && obj.hospitalRoundId;
                $scope.dischargeExternalPatient = obj && obj.dischargeExternalPatient;
                $scope.dashboardConfigurations = LocalStorageRepository.getPatientDashboardConfigurations('all');
                setup();
            });

            $scope.$on('$destroy', function() {
                deregister();
            });

            $scope.dischargePatient = function dischargePatient() {
                if (!$scope.dischargeExternalPatient) {
                    return;
                }

                $scope.dischargingPatient = true;

                ExternalPatientsRepository.dischargePatient($scope.hospitalRoundId)
                    .then(function (externalPatient) {
                        $rootScope.$broadcast('ext-patient-discharged', externalPatient);
                    }, function (err) {
                        $rootScope.tryToastModelStateError(err);
                    })
                    .finally(function () {
                        $rootScope.$broadcast('close-context-menu');
                        $scope.dischargingPatient = false;
                    });
            };

            $scope.removeChargeCapture = function removeChargeCapture() {
                $scope.removingChargeCapture = true;

                apConfirm('Are you sure you want to remove the eMDs Round for ' + ($scope.patient.name || 'this patient') + '?', 'Yes', 'No')
                    .then(function(result) {
                        if (result) {
                            ChargeCaptureRepository.removeChargeCapture($scope.chargeCaptureOptions.chargeCaptureId)
                            .then(function (result) {
                                if (result.IsSuccess) {
                                    toaster.pop('success', '', gettext('eMDs Round removed successfully.'));
                                    $rootScope.$broadcast('charge-capture-tile-remove', $scope.chargeCaptureOptions);
                                } else {
                                    toaster.pop('error', '', gettext('Failed to remove eMDs Round.'));
                                }
                            })
                            .catch(function () {
                                toaster.pop('error', '', gettext('An exception occurred while attempting to remove eMDs Round.'));
                            });
                        }
                    })
                    .finally(function () {
                        $rootScope.$broadcast('close-context-menu');
                        $scope.removingChargeCapture = false;
                    });
            };

            $scope.navigateToDashboard = function(data){
                TransitionManager.transition({
                    appRoute: 'patientDashboard',
                    opts: {id: $scope.patient.Id, configId: data},
                });
            };
        }]);